import React, { Component } from 'react';
import AdminTitle from '../../components/AdminTitle';
import BrandEditor from '../../components/BrandEditor';

export default class AdminBrandCreate extends Component {
  render() {
    return (
      <div>
        <AdminTitle title="Create Brand"/>
        <BrandEditor />
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminBrandCreate.js
 **/